import { Component, ViewChild, AfterViewInit, ElementRef, Output, EventEmitter, Input } from '@angular/core';
import { MediaService } from '../peers/media.service';

import { WbService } from '../wb.service';
import { Modal } from 'ng2-modal';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment'
import { ContentParserService } from '../services/content/content-parser.service';
import { Injectable } from '@angular/core';
import { MediaManagerService } from '../services/media/media-manager.service';
import { Headers, RequestOptions, Response, Http } from '@angular/http';
import { ButtonComponent } from "../../utils/button/button.component";
import { TranslateService } from 'ng2-translate/ng2-translate';
import { RecordingManagerService } from '../services/recording/recording-manager.service';
import { ReplayerService, OnReplayer } from '../player/replayer.service';
import { SessionManagerService } from '../services/session/session-manager.service';
import { WsService2 } from '../services/ws/ws.service';
declare var $;
declare var videojs;
@Component({
    selector: "dskl-player-manager",
    templateUrl: 'player-manager.component.html',

})

export class PlayerManagerComponent implements OnReplayer{

    @ViewChild("contentModal") contentModal: Modal;
    @ViewChild("noPluginModal") noPluginModal: Modal;
   @ViewChild("splitConfirmtModal") splitConfirmtModal:Modal;
   @ViewChild("addConfirmModal") addConfirmModal:Modal;
   @ViewChild("cantPubslishTooManyFilesModal" )cantPubslishTooManyFilesModal : Modal;
   @ViewChild("errorPublishingModal") errorPublishingModal:Modal;
   @ViewChild("closeErrorModal") closeErrorModal: Modal;
   @ViewChild("successfullyPublished") successfullyPublished: Modal;
    @ViewChild("split") split: ButtonComponent;
    files = [];
    onStartPlaying(){
        this.contentModal.close();
    }
    onStopPlaying(){

    }
    isReady(){

    }
    open() {
        this.files = [];

        this.contentModal.open();
        this.getContentsByTeacherHash()

    }
    currentRecordingContainer;
    constructor(private router: Router, private http: Http, private parserService: ContentParserService, private wsService: WsService2,
        private mediaManagerService: MediaManagerService, private translate: TranslateService, private recordingManager: RecordingManagerService, private replayerService: ReplayerService, private sessionManager: SessionManagerService) {
        parserService.setCallback(this);
        replayerService.registerForReplaying(this);
        this.translate.get('WB_CONTENT.DEFAULT_FILE_NAME').subscribe((res: string) => { 
            this.defaultFileName = res;
        });
    }
    defaultFileName = "";
    addFirst={name:"", id:0};
    addSecond={name:"", id:0};
    addFiles(){
        this.addAtEnd(this.addSecond.id, this.addFirst.id);
    }
    closeAddConfirm(){
        this.addConfirmModal.close();
        this.contentModal.open();
    }
    public dropped(item, over) {
        if (item.id == over.id) {
            return;
        }
        this.addFirst = over;
        this.addSecond = item;
        this.contentModal.close();
        this.addConfirmModal.open();
      /*  let result = confirm(`Сигурни ли сте че искате да залепите тези 2 файла: ${item.name} - ${over.name}`)
        if (result) {
            this.addAtEnd(item.id, over.id)
        }*/
    }

    askForNewFiles;
    shouldAskForNewFiles = false;
    ngOnInit() {
        this.askForNewFiles = setInterval(() => {
            if (this.shouldAskForNewFiles) {
                setTimeout(()=>{ this.getContentsByTeacherHash(true);}, 1000)
               

            }
        }, 1000)
    }
    private extractData(res: Response) {
        this.loading = false;
        this.ready = true;
        this.connected = true;
        let body = res.json();
        return body || {};
    }
    connected = false
    ready = false;
    isFileSelected() {
        return this.replayerService.getRecordContainerId() != null;
    }
    // postToDaskalBackend(url, body){
    //   return this.p(environment.backendUrl, url, body);
    //}
    post(url, body) {
        return this.p(environment.wbBackendUrl + "player/" + this.replayerService.getUserHash() + "/", url, body);
    }
    p(backend, url, body) {
        // url =  + url;
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers, withCredentials: false });
        this.loading = true;
        return this.http.post(backend + url, body, options)
            .map(this.extractData.bind(this)).catch(this.handleError.bind(this))

    }
    loading = false;

    isReadyForPublish() {
        return this.workingFiles.length == 1 && !this.workingFiles[0]["published"];
    }
    isReadyForUnpublish() {
        return this.workingFiles.length == 1 && this.workingFiles[0]["published"];
    }
    private handleError(error: Response | any) {
        this.loading = false;
        this.connected = false;
        this.ready = true;
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Promise.reject(errMsg);
    }
    workingFiles = [];
    deletedFiles = [];
    getContentsByTeacherHash(refresh=false) {
        var self = this;
        console.log("Will get contents")
        this.post("", { name: name }).subscribe(r => {
            var f = r["object"].array;
            if (refresh && f.length==self.deletedFiles.length+self.workingFiles.length)return
            self.deletedFiles = [];
            self.workingFiles = [];
          
            
            
            let i = 1;
            for (let a of f) {
                if (a.deleted) {
                    self.deletedFiles.push(a);
                    if (!a.name) {
                        a.name = self.defaultFileName+" " + i++
                    }
                } else {
                    if (!a.name) {
                        a.name =  self.defaultFileName+" " + i++
                    }
                    self.workingFiles.push(a);
                }
            }
            let last = self.workingFiles[self.workingFiles.length - 1];
            if (!this.currentRecordingContainer) {
                if (sessionStorage.getItem('selected')) {
                    this.currentRecordingContainer = self.workingFiles.find((file) => { return file.id == sessionStorage.getItem('selected') })
                } else {
                    this.currentRecordingContainer = last;

                }
            }
            console.log('last', this.currentRecordingContainer)

        });
    }
    /*
    rename(value, id) {
        var self = this;

        var fid = this.content["workingFiles"][id].id;
        this.post(this.content["id"] + "/" + fid + "/rename", { name: value }).subscribe(r => {
            self.getContentsByTeacherHash();

        });
    }
    deleteFile(id) {
        var self = this;
        var fid = this.content["workingFiles"][id].id;
        this.post(this.content["id"] + "/" + fid + "/delete", null).subscribe(r => {
            self.getContentsByTeacherHash();
        });
    }
    undeleteFile(id) {
        var self = this;

        this.post(this.content["id"] + "/" + id + "/undelete", null).subscribe(r => {
            self.getContentsByTeacherHash();
        });
    }
    */
    closePublishTooManyFilesError(){
        this.contentModal.open();
        this.cantPubslishTooManyFilesModal.close();
    }
    publish(to, id) {
       /* if (this.workingFiles.length > 1){
            this.contentModal.close();
            this.cantPubslishTooManyFilesModal.open();
            return;
        }*/
        var self = this;
        console.log("Will publish ", this.replayerService.getRecordContainerId());
        this.post((to ? "/publish/" : "/unpublish/") + id, null).subscribe(r => {
            console.log("Got published ", r);
            self.workingFiles[0].published = r["object"]["published"];
            var hash = r["object"]["publishedHash"];
            //  self.postToDaskalBackend("teacher/content/"+this.replayerService.getUserHash()+"/"+hash, null).subscribe(r=>{
            //window.alert("published")
            this.contentModal.close();
            this.successfullyPublished.open();
            //     self.getContentsByTeacherHash();

            // });
        }, error => {
            this.contentModal.close();   
            this.errorPublishingModal.open()
           
        });
    }
    closePublishError(){
        this.errorPublishingModal.close()
        this.contentModal.open();
    }
    rename(value, id) {
        var self = this;


        this.post("/rename/" + id, { name: value }).subscribe(r => {
            self.getContentsByTeacherHash();

        });
    }
    deleteFile(id, d) {
        var self = this;

        this.post("/delete/" + id + "/" + d, null).subscribe(r => {
            self.getContentsByTeacherHash();
        });
    }
    addAtEnd(id, first) {
        var self = this;
        this.post("append/" + first + "/" + id, null).subscribe(r => {

            self.getContentsByTeacherHash();
            self.addConfirmModal.close();
            self.contentModal.open();
        });
    }

    isPlaying() {
        return this.replayerService.isPlaying();
    }
    showSplitConfirmModal(){
        this.contentModal.close()
        this.splitConfirmtModal.open();
    }
    cancelSplit(){
        this.splitConfirmtModal.close();
        this.contentModal.open()
        
    }
    splitFile() {
      
            let currentTime = this.replayerService.getCurrentTime();
            // var recordContainerId = this.replayerService.getRecordContainerId();
            var recordingContainerId = this.replayerService.getRecordContainerId();
            var recordingId = this.replayerService.getCurrentRecordId();

            var self = this;
            this.split.loading();
            console.log("Will split the file")
            var states = this.sessionManager.getCurrentStates();
            var rstates = [];
            for (let s of states) {
                rstates.push({ currentState: s.currentState, id: s.pageId });
            }
            this.post("/split/", { recordingId: recordingId, recordingContainerId: recordingContainerId, 
                time: (currentTime + "").split(".")[0], states: rstates }).subscribe(r => {
                console.log("Got ", r);
                self.split.reset();
                
                self.getContentsByTeacherHash();
                try{
                     window.close();
                }catch(error){
                    console.log("Cant close current window")
                    self.closeErrorModal.open();
                    self.splitConfirmtModal.close();
                    
                }
            }, error => {
                self.split.reset();
            });
        
    }
    play() {
        //if (this.hasEnded()){
        this.replayerService.seek(0);
        //}else{
        this.replayerService.startPlaying();
        //}
    }
    pause() {
        this.replayerService.stopPlaying();
    }
    concatFiles(fileId1, fileId2) {

    }

    hasEnded() {
        return this.replayerService.hasEnded();
    }

    newWindow;
    playVideo(id) {


        if (id == this.replayerService.getRecordContainerId()) {
            this.play();
        } else {
            //this.router.navigate(['player/' + this.replayerService.getUserHash() + "/" + id])
            sessionStorage.setItem('selected', id)
            let newWindow = window.open(environment.urlPlayer + this.replayerService.getUserHash() + "/" + id)
            console.log(environment.urlPlayer + this.replayerService.getUserHash() + "/" + id)
            this.shouldAskForNewFiles = true;
            let self = this;
            newWindow.onbeforeunload = function () {
                window.focus()
                self.shouldAskForNewFiles = false;
                sessionStorage.removeItem('selected')
            }
            this.currentRecordingContainer = this.workingFiles.find((file) => { return file.id == id });
        }
    }
    newRecord() {
        this.replayerService.setRecordContainerId(null);
        // this.router.navigate(['wb/' + this.replayerService.getUserHash()])
        sessionStorage.removeItem('selected')
        window.close()
    }

}   


// WEBPACK FOOTER //
// /app/src/app/wb/tools/player-manager.component.ts